/*
 *
 * EditService reducer
 *
 */

import { fromJS } from 'immutable';
import {
  addPoint,
  removePoint,
  insertPoint,
  movePoint,
  replacePath,
  routing,
  editCurrent,
} from './functions';

import {
  EDIT_ADD,
  EDIT_CLEAR,
  EDIT_CREATE,
  EDIT_DELETE,
  EDIT_DRAG,
  EDIT_EDIT,
  EDIT_GEOCODE,
  EDIT_IMPORT,
  EDIT_INSERT,
  EDIT_MOVE,
  EDIT_REPLACE,
  EDIT_ROUTING,
  EDIT_SAVE,
  EDIT_UNDO,
} from './constants';
import { GPX_UPLOAD_SUCCESS } from '../ImportGpx/constants';
import { CHANGE_ENTITY_SUCCESS } from '../Rest/constants';

export const emptyRoute = fromJS({});
export const newRoute = fromJS({
  legs: [],
  distance: 0,
  meta: {},
  kmMarkers: [],
});

export const initialState = newRoute;

export const stack = [];

function editServiceReducer(state = initialState, action) {
  const { type, id, point, travelMode, options, forceEmpty } = action;
  switch (type) {
    case EDIT_ADD:
      stack.push(state);
      return addPoint(state, point, travelMode);
    case EDIT_CLEAR:
      stack.length = 0;
      return !forceEmpty && state.get('legs') && state.get('legs').size > 0
        ? newRoute
        : emptyRoute;
    case EDIT_CREATE:
      stack.push(state);
      return newRoute;
    case EDIT_DELETE:
      stack.push(state);
      return removePoint(state, id, travelMode);
    case EDIT_DRAG:
      return movePoint(state, id, point);
    case EDIT_EDIT:
    case GPX_UPLOAD_SUCCESS:
      return fromJS(editCurrent(action.route));
    case EDIT_GEOCODE:
      return state.update('meta', meta => meta.merge(action.address));
    case EDIT_IMPORT:
      return state;
    case EDIT_INSERT:
      stack.push(state);
      return insertPoint(state, id, point, travelMode);
    case EDIT_MOVE:
      stack.push(state);
      return movePoint(state, id, point, travelMode);
    case EDIT_REPLACE:
      stack.push(state);
      return replacePath(state, id, travelMode);
    case EDIT_ROUTING:
      return routing(state, action);
    case EDIT_SAVE:
      return state;
    case EDIT_UNDO:
      return stack.pop();
    case CHANGE_ENTITY_SUCCESS:
      if (options.entity === 'routes') {
        return emptyRoute;
      }
      return state;
    default:
      return state;
  }
}

export default editServiceReducer;
